module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ua":{"wrong_old":"Помилковий старий пароль","pass not match":"Паролі не співпадають","pass insecure":"Пароль має містити від 8 символів, серед яких має бути мінімум 1 цифра, 1 велика літера, 1 маленька літера.","success_change":"Пароль успішно змінено, увійдіть до додатку з новим паролем","close":"Закрити"}}')
  delete Component.options._Ctor
}
